import { ApiError } from '@/util/errors/api-error'

export const workEmailPolicyErrorCode = 'blocked_work_email'

type WorkEmailPolicyErrorResponse = {
  code: typeof workEmailPolicyErrorCode
  detail: string
}

export class BlockedWorkEmailApiError extends ApiError {
  override detail: string

  constructor(detail: string) {
    super(400, detail, detail)
    this.name = 'BlockedWorkEmailApiError'
    this.detail = detail
  }
}

export function getWorkEmailPolicyErrorResponse(value: unknown): WorkEmailPolicyErrorResponse | undefined {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return undefined
  }

  const response = value as { code?: unknown; detail?: unknown }
  if (response.code !== workEmailPolicyErrorCode || typeof response.detail !== 'string') {
    return undefined
  }

  return { code: workEmailPolicyErrorCode, detail: response.detail }
}

export function getWorkEmailPolicyErrorMessage(value: unknown): string | undefined {
  return getWorkEmailPolicyErrorResponse(value)?.detail
}
